module.exports = __webpack_public_path__ + "img/sf.ddc1cb73.png";